export const QuestionnaireQuickAccessConfig = {
  ACTIVE: true
};
